// 详情相关接口-提供调用

import { API, http } from './index';

// 企微侧边栏学员详情展示
export const displayCustomerDetails = data => http.get(API.detail.displayCustomerDetails, data);
// 查询网校客户的订单
export const queryOnlineSchoolCustomerOrder = data => http.get(API.detail.queryOnlineSchoolCustomerOrder, data);
// 编辑企微侧边栏学员详情
export const editCustomerWeComBarDetails = data => http.post(API.detail.editCustomerWeComBarDetails, data);
// 根据订单ID查询缴费中、已支付支付明细信息 (排除已作废的支付凭证信息)
export const selectPayWayDetailsByOrderId = data => http.get(API.detail.selectPayWayDetailsByOrderId, data);
//通过渠道选项获取广告位
export const queryAdvertisingSpaceByChannel = data => http.get(API.detail.queryAdvertisingSpaceByChannel, data);
//复制记录提交
export const saveCopyLog = (data) => http.post(API.detail.saveCopyLog, data);
//侧边栏查询可赠送课程的下拉站点
export const querySideBarClassTypeWebsiteList = data => http.get(API.detail.querySideBarClassTypeWebsiteList, data);
// 侧边栏查询可赠送的课程列表
export const querySideBarClassTypePageList = data => http.get(API.detail.querySideBarClassTypePageList, data);
//侧边栏赠送课程
export const giftSideBarCourse = (data) => http.post(API.detail.giftSideBarCourse, data);
// 查询赠送课程用户是否有权限
export const queryGiftCourseUserAuthority = data => http.get(API.detail.queryGiftCourseUserAuthority, data);



export default {
    displayCustomerDetails,
    queryOnlineSchoolCustomerOrder,
    editCustomerWeComBarDetails,
    selectPayWayDetailsByOrderId,
    queryAdvertisingSpaceByChannel,
    saveCopyLog,
    querySideBarClassTypeWebsiteList,
    querySideBarClassTypePageList,
    giftSideBarCourse,
    queryGiftCourseUserAuthority
};
